import { render } from "./EmployeeMasterlist.vue?vue&type=template&id=61b10fb2"
import script from "./EmployeeMasterlist.vue?vue&type=script&lang=js"
export * from "./EmployeeMasterlist.vue?vue&type=script&lang=js"

import "./EmployeeMasterlist.vue?vue&type=style&index=0&id=61b10fb2&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__